import React from 'react';
const Header = () => {
  return <header className="bg-[#c19a3c] py-4 px-6 md:px-12 flex justify-between items-center" data-id="element-67">
      <h1 className="text-white text-xl md:text-2xl font-serif" data-id="element-68">
        Maverick Legacy Foundation
      </h1>
      <div className="flex items-center gap-8" data-id="element-69">
        <a href="#story" className="text-white hover:underline font-serif" data-id="element-70">
          Our Story
        </a>
        <a href="#contact" className="bg-white text-[#c19a3c] px-6 py-2 rounded-full font-medium hover:bg-opacity-90 transition-all" data-id="element-71">
          Get In Touch
        </a>
      </div>
    </header>;
};
export default Header;